export default __webpack_public_path__ + "static/media/full-band.d01b4ab4.jpg";